import styled from "styled-components";
import { NoData } from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";
import { LoadingSpinner } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import { ColumnChartContainer as ColumnChartWrapper } from "pro-features/components/Chart/src/components/column/Styled";
import { useTopPlayersChartData } from "app/pages/industry-analysis/hooks/useTopPlayersChartData";
import { TopPlayersWidgetChart } from "./TopPlayersWidgetChart";

const contentHeight = 350;

const LoaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: ${contentHeight}px;
`;

export const TopPlayersWidgetChartLoader = () => {
    const { isLoading, data } = useTopPlayersChartData();

    if (isLoading) {
        return (
            <LoaderWrapper>
                <LoadingSpinner />
            </LoaderWrapper>
        );
    }

    if (data === undefined) {
        return (
            <NoData
                paddingTop="80px"
                noDataTitleKey="global.nodata.notavilable"
                noDataSubTitleKey="workspaces.marketing.nodata.subtitle"
            />
        );
    }

    return (
        <ColumnChartWrapper>
            <TopPlayersWidgetChart
                chartHeight={contentHeight}
                isPeriodOverPeriod={data.isPeriodOverPeriod}
                chartData={data.chartData}
                comparisonChartData={data.comparisonChartData}
            />
        </ColumnChartWrapper>
    );
};
